/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const dispatchInvoiceDetailsByPQR = (data) => ({
  type: actionTypes.GET_INVOICE_DETAILS_BY_PQR,
  payload: data,
});

export const dispatchInvoiceDetailsByInvoiceNum = (data) => ({
  type: actionTypes.GET_INVOICE_DETAILS_BY_INVOICE_NUM,
  payload: data,
});

export const dispatchGetHandlingCode = (data) => {
  return {
    type: actionTypes.GET_HANDLING_CODE,
    payload: data,
  };
};
export const dispatchGetBalanceCode = (data) => {
  return {
    type: actionTypes.GET_BALANCE_CODE,
    payload: data,
  };
};

export const dispatchGetInvoiceStatusCode = (data) => {
  return {
    type: actionTypes.GET_INVOICE_CODE,
    payload: data,
  };
};

export const dispatchInvoiceQuarter = (data) => {
  return {
    type: actionTypes.GET_INVOICE_QUARTER,
    payload: data,
  };
};

export const dispatchInvoiceOtherQuarter = (data) => {
  return {
    type: actionTypes.GET_INVOICE_OTHER_QUARTER,
    payload: data,
  };
};

export const dispatchInvoiceQuarterTotals = (data) => {
  return {
    type: actionTypes.GET_INVOICE_QUARTER_TOTALS,
    payload: data,
  };
};

export const dispatchSavedInvoiceDetails = (data) => {
  return {
    type: actionTypes.SAVED_INVOICE_DETAILS,
    payload: data,
  };
};

export const dispatchDrugActivity = (data) => {
  return {
    type: actionTypes.GET_DRUG_ACTIVITY,
    payload: data,
  };
};

export const dispatchGetCheckLogByInvoiceNum = (data) => {
  return {
    type: actionTypes.GET_CHECK_LOG_BY_INVOICE_NUM,
    payload: data,
  };
};

export const setErrorMessagesData = (data) => {
  return {
    type: actionTypes.SET_ERROR_MESSAGES,
    payload: data,
  };
};

export const setNoRecordFound = (data) => {
  return {
    type: actionTypes.SET_NO_RECORD_FOUND,
    payload: data,
  };
};

export const setSaveRequest = (data) => {
  return {
    type: 'SET_SAVE_REQUEST',
    payload: data,
  };
};

export const searchInvoiceRequestAction = (data) => {
  return {
    type: 'SEARCH_INVOICE_REQUEST',
    payload: data,
  };
};

export const setSelectedClient = (data) => {
  return {
    type: actionTypes.SET_SELECTED_CLIENT,
    payload: data,
  };
};

export const setInvoiceNumber = (data) => {
  return {
    type: actionTypes.SET_INVOICE_NUMBER,
    payload: data,
  };
};

export const setInvoiceOtherQtrIndex = (data) => {
  return {
    type: 'SET_INVOICE_OTHER_QTR_INDEX',
    payload: data,
  };
};

export const setInvoiceOtherHideZeroBalance = (data) => ({
  type: actionTypes.SET_INVOICE_OTHER_HIDE_ZERO_BALANCE,
  payload: data,
});

export const setInvoiceOtherSelectedQtr = (data) => ({
  type: actionTypes.SET_INVOICE_OTHER_SELECTED_QTR,
  payload: data,
});

export const setTabDetails = (data) => {
  return {
    type: 'TAB_DETAILS',
    payload: data,
  };
};


export const setCheckLogOpen = (data) => {
  return {
    type: 'SET_CHECK_LOG_OPEN',
    payload: data,
  };
};

export const setDefaultQtr = (data) => {
  return {
    type: actionTypes.SET_DEFAULT_QTR,
    defaultQtr: data,
  };
};
export const setDisplayInvoiceObj = (data) => {
  return {
    type: actionTypes.DISPLAY_INVOICE_OBJ,
    displayInvoiceObj: data,
  };
};
export const resetDisplayInvoiceStore = () => {
  return {
    type: actionTypes.RESET_DISPLAY_INVOICE_STORE,
  };
};

export const setMfgSelected = (data) => {
  return {
    type: actionTypes.MFG_SELECTED,
    mfgSelected: data,
  };
};

const isNoRecordPayload = (data) => {
  if (data == null || data === '') return true;
  if (typeof data === 'string') {
    return data.toLowerCase().includes('no record');
  }
  if (Array.isArray(data) && data.length === 0) return true;
  return false;
};

export const searchInvoiceByPQR = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SEARCH_INVOICE_BY_PQR, values)
    .then((response) => {
      const data = response?.data?.data;
      if (isNoRecordPayload(data)) {
        dispatch(dispatchInvoiceDetailsByPQR([]));
        return { isNoRecord: true, data: [] };
      }
      dispatch(dispatchInvoiceDetailsByPQR(data));
      return { isNoRecord: false, data };
    })
    .catch((error) => {
      const errorData = error?.response?.data;
      dispatch(dispatchInvoiceDetailsByPQR(errorData));
      return { isNoRecord: isNoRecordPayload(errorData?.data ?? errorData), data: errorData };
    });
};

export const getInvoiceDetailsByInvoiceNum = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_INVOICE_DETAILS_BY_INVOICE_NUM, values)
    .then((response) => {
      dispatch(dispatchInvoiceDetailsByInvoiceNum(response.data));
      return response.data;
    })
    .catch((error) => {
      const errorData = error?.response?.data;
      dispatch(dispatchInvoiceDetailsByInvoiceNum(errorData || { data: 'No record found' }));
      return errorData;
    });
};

export const getHandlingCode = (values) => (dispatch) => {
  return axios
    .get(`${serviceEndPoint.GET_CHECK_PAYEE}?codeDomainKey=${values}`)
    .then((response) => {
      return dispatch(dispatchGetHandlingCode(response.data));
    })
    .catch((response) => {
      dispatch(dispatchGetHandlingCode(response));
    });
};
export const getBlanceCode = (values) => (dispatch) => {
  return axios
    .get(`${serviceEndPoint.GET_CHECK_PAYEE}?codeDomainKey=${values}`)
    .then((response) => {
      return dispatch(dispatchGetBalanceCode(response.data));
    })
    .catch((response) => {
      dispatch(dispatchGetBalanceCode(response));
    });
};
export const getInvoiceStatusCode = (values) => (dispatch) => {
  return axios
    .get(`${serviceEndPoint.GET_CHECK_PAYEE}?codeDomainKey=${values}`)
    .then((response) => {
      return dispatch(dispatchGetInvoiceStatusCode(response.data));
    })
    .catch((response) => {
      dispatch(dispatchGetInvoiceStatusCode(response));
    });
};

export const getInvoiceQuarter = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_INVOICE_QUARTER, values)
    .then((response) => {
      let data = response.data?.data?.map((item) => {
        item.stateAmtReimbursed = item.totalReimsedAmt;
        item.totalRebateAmt = item.unitRebateAmt * item.totalReimsedUnit;
        item.totalReimsedAmt =
          item.totalReimsedAmt +
          item.copayAmt +
          item.tplAmt +
          item.deductibleAmt;
        item.amountDue = item.unitRebateAmt * item.totalReimsedUnit;
        return item;
      });
      dispatch(dispatchInvoiceQuarter(data));
    })
    .catch((error) => {
      dispatch(dispatchInvoiceQuarter(error.response.data));
    });
};

export const getInvoiceOtherQuarter = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_INVOICE_OTHER_QUARTER, values)
    .then((response) => {
      dispatch(dispatchInvoiceOtherQuarter(response.data));
    })
    .catch(() => {
      dispatch(dispatchInvoiceOtherQuarter([]));
    });
};

export const getInvoiceQuarterTotals = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_INVOICE_QUARTER_TOTALS, values)
    .then((response) => {
      dispatch(dispatchInvoiceQuarterTotals(response.data));
    })
    .catch((error) => {
      dispatch(dispatchInvoiceQuarterTotals(error.response));
    });
};

export const saveInvoiceDetails = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SAVE_INVOICE_DETAILS, values)
    .then((response) => {
      dispatch(dispatchSavedInvoiceDetails(response.data));
    })
    .catch((error) => {
      dispatch(dispatchSavedInvoiceDetails(error.response));
    });
};
// call API for dropdown list
export const getAllCommonDropdownList = (value) => {
  return axios
    .post(serviceEndPoint.SYSTEM_LIST_DROPDOWN, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};
// call API for dropdown list
export const getInvoiceReasonList = (value) => {
  return axios
    .get(`${serviceEndPoint.GET_CHECK_PAYEE}?codeDomainKey=${value}`)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};
export const getDrugActivity = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SHOW_DRUG_ACTIVITY, values)
    .then((response) => {
      dispatch(dispatchDrugActivity(response.data));
    })
    .catch((error) => {
      dispatch(dispatchDrugActivity(error.response));
    });
};

export const getCheckLogByInvoiceNum = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.CHECK_LOG_BY_INVOICE_NUMBER}?invoiceNum=${values}`)
    .then((response) => {
      return dispatch(dispatchGetCheckLogByInvoiceNum(response.data));
    })
    .catch(() => {
      dispatch(dispatchGetCheckLogByInvoiceNum({}));
    });
};

export const getMaxQuarterForFreezeDt = () => (dispatch) => {
  return axios
    .get(`${serviceEndPoint.GET_MAXQUARTER_FOR_FREEZE_DT}`)
    .then((response) => {
      return dispatch(setDefaultQtr(response.data));
    })
    .catch((response) => {
      dispatch(setDefaultQtr(response.date));
    });
};

export const setInvoiceQtr = (payload) => {
  return {
    type: actionTypes.INVOICE_QTR,
    payload,
  };
};
export const clearReduxDisplayInvoiceSearchScreen = () => (dispatch) => {
  dispatch(searchInvoiceRequestAction({}));
  dispatch(setDefaultQtr(''));
  dispatch(setErrorMessagesData([]));
  dispatch(dispatchInvoiceDetailsByPQR([]));
  dispatch(setSelectedClient(''));
  dispatch(setInvoiceNumber(''));
  dispatch(setNoRecordFound(false));
};

export const clearReduxDisplayInvoiceDetailScreen = () => (dispatch) => {
  dispatch(dispatchGetCheckLogByInvoiceNum({}));
  dispatch(dispatchSavedInvoiceDetails(''));
  dispatch(setErrorMessagesData([]));
  dispatch(dispatchGetHandlingCode([]));
  dispatch(setDisplayInvoiceObj({}));
  dispatch(dispatchGetInvoiceStatusCode([]));
  dispatch(dispatchInvoiceQuarter([]));
  dispatch(dispatchInvoiceQuarterTotals([]));
  dispatch(dispatchGetBalanceCode([]));
  dispatch(dispatchInvoiceOtherQuarter([]));
  dispatch(setSaveRequest({}));
  dispatch(dispatchInvoiceDetailsByInvoiceNum({}));
};
